import React, { useState, useRef, useEffect } from 'react';

function ChatInput({ onSend, onCancel, sending, disabled, urgent, onToggleUrgent }) {
  const [text, setText] = useState('');
  const textareaRef = useRef(null);

  useEffect(() => {
    if (!sending && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [sending]);

  const adjustHeight = () => {
    const el = textareaRef.current;
    if (el) {
      el.style.height = 'auto';
      el.style.height = Math.min(el.scrollHeight, 150) + 'px';
    }
  };

  const handleSubmit = () => {
    const trimmed = text.trim();
    if (!trimmed || sending || disabled) return;
    onSend(trimmed);
    setText('');
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className="chat-input-area">
      <div className="chat-urgency-row">
        <button
          className={`chat-urgency-toggle ${urgent ? 'urgent' : 'normal'}`}
          onClick={onToggleUrgent}
          title={urgent ? 'Modo Urgente: resposta imediata (streaming)' : 'Modo Normal: processamento em batch (50% mais barato, ate 24h)'}
        >
          <span className="chat-urgency-icon">{urgent ? '\u26A1' : '\u23F3'}</span>
          <span className="chat-urgency-label">{urgent ? 'Urgente' : 'Normal'}</span>
        </button>
        <span className="chat-urgency-hint">
          {urgent ? 'Resposta imediata' : 'Batch — 50% mais barato'}
        </span>
      </div>
      <div className="chat-input-wrapper">
        <textarea
          ref={textareaRef}
          className="chat-input"
          placeholder={urgent ? 'Digite sua mensagem...' : 'Digite sua mensagem (sera processada em batch)...'}
          value={text}
          onChange={(e) => { setText(e.target.value); adjustHeight(); }}
          onKeyDown={handleKeyDown}
          rows={1}
          disabled={sending || disabled}
        />
        {sending ? (
          <button className="chat-cancel-btn" onClick={onCancel} title="Cancelar">
            &#x25A0;
          </button>
        ) : (
          <button
            className="chat-send-btn"
            onClick={handleSubmit}
            disabled={!text.trim() || disabled}
            title="Enviar"
          >
            &#x27A4;
          </button>
        )}
      </div>
    </div>
  );
}

export default ChatInput;
